import { render, staticRenderFns } from "./FilesView.vue?vue&type=template&id=93b23860&scoped=true"
import script from "./FilesView.vue?vue&type=script&lang=js"
export * from "./FilesView.vue?vue&type=script&lang=js"
import style0 from "./FilesView.vue?vue&type=style&index=0&id=93b23860&prod&lang=scss"
import style1 from "./FilesView.vue?vue&type=style&index=1&id=93b23860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b23860",
  null
  
)

export default component.exports